import { geometry, Vector2 } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';

/**
 * Use
 * This is used on the home D icon to create the
 * Also used on all the screens layouts that a cycled through
 */
export class ImageGridLayout implements particles.ParticleLayout {
	public get(
		count: number,
		position: geometry.Vector2,
		size: geometry.Size,
		config: any = null,
		skip: boolean = false
	): Array<particles.ParticleLookupProps> {
		//Pixel-data points carry layout extras beyond x/y (see HomeFieldScreensPixelDataConfig):
		let gridPositions: Array<Vector2 & { col?: number; row?: number; rgba?: any; radius?: number }> =
			config.pixelData;
		let points: Array<particles.ParticleLookupProps> = [];
		let relativeX: number = position.x;
		let relativeY: number = position.y;

		let increaseCountPerStep = 1;

		if (skip && count < gridPositions.length) {
			increaseCountPerStep = gridPositions.length / count;
		}

		for (let id = 0; id < count; id++) {
			let i = id;
			if (skip) {
				i = Math.round(increaseCountPerStep * id);
			}

			if (gridPositions[i]) {
				relativeX = position.x + gridPositions[i].x * size.w;
				relativeY = position.y + gridPositions[i].y * size.h;

				points.push({
					x: relativeX,
					y: relativeY,
					col: gridPositions[i].col,
					row: gridPositions[i].row,
					rgba: gridPositions[i].rgba,
					radius: gridPositions[i].radius
				});
			} else {
				points.push({
					x: -0.1,
					y: 0 + Math.random()
				});
			}
		}

		return points;
	}
}
